import React from "react"
import styled from "styled-components"

import { socialMedia } from "@config"
import { Icon } from "@components/icons"

const StyledFooter = styled.footer`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: auto;
  min-height: 70px;
  padding: 16px;
  text-align: center;
  text-decoration: none;
  list-style: none;
`
const StyledSocialLinks = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    a {
      padding: 8px;

      &:hover,
      &:focus {
        transform: translateY(-3px);
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`

const StyledCredit = styled.div`
  color: #ff2a6d;
  font-size: 14px;
  line-height: 1;

  a {
    padding: 10px;
  }

  .github-stats {
    margin-top: 10px;

    & > span {
      display: inline-flex;
      align-items: center;
      margin: 0 7px;
    }
    svg {
      display: inline-block;
      margin-right: 5px;
      width: 14px;
      height: 14px;
    }
  }
`

const Footer = () => {
  return (
    <StyledFooter>
      <StyledSocialLinks>
        {socialMedia &&
          socialMedia.map(({ url, name }, i) => (
            <li key={i}>
              <a href={url} aria-label={name} target="_blank" rel="noreferrer">
                <Icon name={name} />
              </a>
            </li>
          ))}
      </StyledSocialLinks>

      <StyledCredit tabindex="-1">
        <a href="https://github.com/benoah">
          <div>Designed &amp; Built by Ben Noah</div>
        </a>
      </StyledCredit>
    </StyledFooter>
  )
}

export default Footer
